<template>
    <el-drawer
        title="配置温馨提示"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="500px"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
                size="medium"
            >   
				
                <el-form-item prop="content" label="温馨提示:">                    
					<!-- <tinymce v-model="formData.content" :height="500" :toolbar="toolbar" :menubar="false" v-if="reFresh" maxlength="10" show-word-limit></tinymce> -->
					<el-input
					    v-model="formData.content"
					    type="textarea"
					    placeholder="请输入温馨提示"
					    :rows="10"
						maxlength="500"
						show-word-limit
					></el-input>
					<div class="color-danger">温馨提示会在演出售后相关页面展示给用户</div>
                </el-form-item>
				
				
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确认</el-button
            >
        </div>
    </el-drawer>
</template>

<script>

const defaultData = {    
    content:'',
}

export default {
	props:{
	   data:{
	       type: String,
	       default: null
	   }
	},
	
    data(){
        return{
			
            drawerShow: false,
            btnLoading: false,
            formData:{
                ...defaultData
            },
            rules:{
                content:[{ required: true, message: "请填写温馨提示", trigger:"blur" }]
            },
			reFresh:false,
			
        }
    },
    methods:{
        close(){
            this.$refs.formData.resetFields();
            this.drawerShow = false;            
            this.formData = {
                ...defaultData
            }
        },
        show(){
			this.formData.content = this.data
            this.drawerShow = true;
			this.reFresh = true;
        },
        submitForm(){
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;    
                    this.$request({
                        url: '/refundTicketAudit/setting/tips',
                        data: {
							...this.formData                                             
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
								this.$emit('onUpdate');
								this.close()                               
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });   
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>